import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from 'react';
import { Controller } from 'react-hook-form';
import { removePhoneFormat } from '../../utils/utils';
const PhoneExtInput = ({ control, name, label, className, }) => {
    const id = useId();
    return (_jsx(Controller, { control: control, name: name, render: ({ field: { onChange, ...field }, fieldState: { invalid, error } }) => {
            return (_jsxs("div", { className: `control-group ${className} ${invalid && 'error'}`, children: [_jsx("label", { htmlFor: id, children: label }), _jsx("div", { className: "phone-input-wrapper", children: _jsx("input", { ...field, id: id, type: "text", inputMode: "tel", placeholder: "( ____ )", onChange: (e) => onChange(removePhoneFormat(e.target.value)), maxLength: 10 }) }), error?.message && error.type !== 'required' && _jsx("p", { className: "error-message", children: error.message })] }));
        } }));
};
export default PhoneExtInput;
